import React from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';

function TransferGateIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fill="none"
        d="M0 0h24v24H0V0z"
        id="path2" />
      <g
          id="g8">
        <g
          id="g4750"
          fill="rgba(151,149,85,0.65)"
          transform="matrix(1.1951271,0,0,1.1951271,-2.3224576,-2.1533898)">
          <path
            id="path4"
            d="M 12,7.77 5.61,18 h 12.78 z"
            opacity="0.3" />
          <path
            id="path6"
            d="M 12,4 2,20 H 22 Z M 12,7.77 18.39,18 H 5.61 Z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default TransferGateIcon;

